<template>
    <div class="w-boxcoin-admin" v-if="allowBoxcoin">
        <el-tooltip effect="dark" content="品鉴" placement="top-start">
            <div class="w-boxcoin-block">
                <svg data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 292.56 384" @click="openBoxcoinPop" v-bind:class="'u-icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="cls-1" d="M146.23 249.77l.06-28.33-.08-.34a17.35 17.35 0 002.5-1.41c18.08-14.78 36.23-29.44 54.16-44.44 16.22-13.52 32.18-27.34 46-43.45 15-17.57 24.33-37.13 20.36-61-3.46-20.78-14-36.93-34.09-44.3-26-9.51-49.54-3.07-70.19 14.62-6.44 5.51-12.28 11.71-18.39 17.6-.1-.11-.21-.21-.32-.32l.05-30.7c.67-.55 1.38-1.06 2-1.66a90.93 90.93 0 0139.53-22.5c5.1-1.39 10.3-2.41 15.46-3.59h19.5c5.14 1.25 10.41 2.13 15.4 3.82 30.08 10.2 47.1 31.62 52.88 62.43 5.1 27.14-2.85 51-19.19 72.35a222.24 222.24 0 01-22.23 25.14c-11.2 10.76-23.13 20.77-35 30.82-12.89 10.93-26.06 21.53-39.1 32.29-8.73 7.19-17.43 14.42-26.19 21.57a12.76 12.76 0 01-3.12 1.4z" fill="#e0e5ef"/><path class="cls-2" d="M146.25 271.53h11.19v44.27c3.2 1.31 4.58 0 5.81-2.49 6.92-14.07 14-28.08 21-42.11.6-1.2 1.26-2.37 2-3.79l20.17 10.08c-2 4-3.78 7.75-5.65 11.49-6 12-12.09 24-18 36.12a6.63 6.63 0 00-.06 5c6.1 13.22 12.41 26.35 18.65 39.51.64 1.33 1.21 2.69 1.82 4l-19.47 10.33h-.75c-6.62-14-13.3-28-19.8-42.09-1.2-2.61-2.64-3.65-5.83-2.53v43.93a54 54 0 00-6.36 0c-3.65.43-4.88-.64-4.86-4.63.21-35.66.14-71.37.14-107.09z" fill="#e52f2f"/><path class="cls-3" d="M146.25 271.53c0 35.71.07 71.43-.1 107.14 0 4 1.21 5.06 4.86 4.63a54 54 0 016.36 0l.13.75H135V271.53z" fill="#eb4c36"/><path class="cls-4" d="M0 384l.17-.81H67.4l.1.79z" fill="#f07e6e"/><path class="cls-5" d="M225 384l.1-.79h67.23l.17.81z" fill="#ec6666"/><path class="cls-4" d="M112.39 383.25l.11.79H90l.13-.8z" fill="#f07e6e"/><path class="cls-2" d="M292.33 383.19H225.1l-.12-78.7v-32.83h67.25v22.11h-44.49v22.58h22v22.41h-22.07v22.43h44.66z" fill="#e52f2f"/><path class="cls-3" d="M67.4 383.25H.17q-.06-36.16-.13-72.32v-39.19h22.37v89.51h45zM112.39 383.25H90.13l-.12-87.3v-24.22h22.28c.07.82.2 1.65.2 2.49v107.17c.01.57-.06 1.19-.1 1.86zM146.29 221.44c-26.86-22.39-53.92-44.53-80.47-67.27-13.2-11.3-25.21-23.92-34-39.17-10.09-17.52-12.13-36-5.66-55.17 8.59-25.49 33.18-40.35 59.89-37.07a75.69 75.69 0 0146.05 22.7c4.38 4.43 8.94 8.7 13.41 13l.74.76q0 80.92-.05 161.84z" fill="#eb4c36"/><path class="cls-1" d="M146.26 59.25l-.74-.76c.23 0 .46 0 .68-.05s.22.21.32.32a1.77 1.77 0 01-.26.49z"/><path class="cls-6" d="M146.26 59.25a1.77 1.77 0 00.26-.49c6.11-5.89 12-12.09 18.39-17.6 20.65-17.69 44.2-24.13 70.19-14.62 20.13 7.37 30.63 23.52 34.09 44.3 4 23.85-5.33 43.41-20.36 61-13.78 16.11-29.74 29.93-46 43.45-17.93 14.94-36.08 29.63-54.16 44.41a17.35 17.35 0 01-2.5 1.41q.07-80.94.09-161.86z" fill="#e52e2e"/></svg>
            </div>
        </el-tooltip>
        <el-dialog title="品鉴评分" :visible.sync="visible" custom-class="w-boxcoin-pop" :close-on-click-modal="false" append-to-body>
            <div class="w-boxcoin-admin-content">
                <div class="u-left">
                    <em class="u-label">本月状态</em>
                    已用<b>{{this.used}}</b> 剩余<b>{{this.left}}</b> 总计<b>{{this.total}}</b>
                    <el-progress :percentage="this.total ? 100 - (this.used * 100 / this.total) : 0" :stroke-width="15" :text-inside="true"></el-progress>
                </div>
                <div class="u-list">
                    <em class="u-label">❤️ 品鉴</em>
                    <Contributors v-if="authors && authors.length" :authors="authors" @chosen="handleChosen" />
                    <div class="u-points">
                        <el-radio-group v-model="count">
                            <el-radio :label="item" v-for="item in fitPoints" :key="item" border>
                                <b>{{item}}</b>盒币
                            </el-radio>
                            <el-radio label="custom" border>自定义</el-radio>
                            <el-input v-model="amount" v-show="count === 'custom'" placeholder="输入自定义数量"></el-input>
                        </el-radio-group>
                    </div>
                </div>
                <div class="u-msg">
                    <em class="u-label">📝 寄语</em>
                    <div class="u-input">
                        <el-input
                            v-model="remark"
                            placeholder="请输入寄语（必填）"
                            :minlength="2"
                            :maxlength="30"
                            show-word-limit
                        ></el-input>
                        <el-button :disabled="fetchingCurrentRelease" @click="insertCurrentRelease">插入当前版本</el-button>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" @click="submit" :disabled="!ready || submitting">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { grantBoxcoin } from "../../service/thx.js";
import User from "@jx3box/jx3box-common/js/user";
import { getBreadcrumb } from "@jx3box/jx3box-common/js/api_misc";
import Contributors from './Contributors.vue';
export default {
    name: "BoxcoinAdmin",
    props: ["postType", "postId", "userId", "own", "total", "points", "max", "min", 'authors','client',"category"],
    components: {
        Contributors
    },
    data: function () {
        return {
            visible: false,
            count: 0,

            remark: "辛苦，感谢！",
            left : this.own,
            chosen: '', // 被选中的人
            amount: "",

            submitting: false,
            fetchingCurrentRelease: false,
        };
    },
    computed: {
        used: function () {
            return this.total - this.left;
        },
        ready: function () {
            const count = this.count === "custom" ? this.amount : this.count;
            // 不能给自己打赏，打赏目标不能是自己
            // 打赏数量不能超过剩余数量
            // 打赏数量不能为0
            // 打赏寄语不能为空
            return !!(
                !this.isSelf &&
                !this.targetIsSelf &&
                this.isEnough &&
                count &&
                this.remark
            );
        },
        isNotSelf: function () {
            return this.userId != User.getInfo().uid;
        },
        targetIsSelf: function () {
            return this.chosen == User.getInfo().uid;
        },
        isEnough: function () {
            const count = this.count === "custom" ? this.amount : this.count;
            return this.left && this.left >= count;
        },
        allowBoxcoin : function (){
            return this.postType && this.postId && (this.userId || (this.authors && this.authors.length))
        },
        hostClient : function (){
            return location.href.includes('origin') ? 'origin' : 'std'
        },
        fitPoints : function (){
            const points = this.points.filter(item => item <= this.left)
            if (this.isSignAuthor) {
                // 最大值为1000
                return points.filter(item => item <= 1000)
            }
            return points
        },
        isSignAuthor : function (){
            return User.getInfo().group == 32;
        }
    },
    watch: {
        own : function (val){
            this.left = val
        }
    },
    methods: {
        openBoxcoinPop: function () {
            this.visible = true;
        },
        // 选择要打赏的对象
        handleChosen(userId) {
            this.chosen = userId
        },
        submit: function () {
            this.submitting = true;
            const count = this.count === "custom" ? this.amount : this.count;
            let client = this.client || this.hostClient;
            if (!['std', 'origin', 'all'].includes(client)) {
                client = 'std'
            }
            grantBoxcoin(this.postType, this.postId, this.chosen || this.userId, count, {
                remark: this.remark,
                client : client,
                // 如果有category，传入category
                redirect: this.category ? `/${this.category}/${this.postId}` : undefined
            })
                .then((res) => {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                    });
                    return res.data.data
                })
                .then((data) => {
                    // 1.扣除额度
                    this.left -= this.count;
                    // 2.将修改emit出去
                    this.$emit('updateRecord', data);
                })
                .finally(() => {
                    this.submitting = false;
                    this.visible = false;
                });
        },
        insertCurrentRelease: function() {
            this.fetchingCurrentRelease = true;
            getBreadcrumb(`current-release-${this.hostClient}`).then(res => {
                this.remark += res;
            }).catch(err => {
                this.$message({
                    message: "获取失败",
                    type: "error",
                });
            }).finally(() => {
                this.fetchingCurrentRelease = false;
            });
        },
        init: function () {},
    },
    created: function () {},
    mounted: function () {},
};
</script>
